import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'eguard-quick-panel',
    templateUrl  : './quick-panel.component.html',
    styleUrls    : ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EguardQuickPanelComponent implements OnInit
{
    date: Date;
    settings: any;
    events = [
        {
            'title' : 'New case assigned to you.',
            'detail': '08:00 AM'
        },
        {
            'title' : 'New case assigned to you.',
            'detail': '08:00 AM'
        },
        {
            'title' : 'New case assigned to you.',
            'detail': '08:00 AM'
        },
        {
            'title' : 'New case assigned to you.',
            'detail': '08:00 AM'
        },
    ];
    constructor()
    {
        this.date = new Date();
        this.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

    }

    ngOnInit()
    {

    }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/components/quick-panel/quick-panel.component.ts